import { Plus } from '@good/icons';
import { Button, Popover } from '@good/ui/core';
import CustomViewPopover from 'common-components/custom-views/popover/CustomViewPopover';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BookingView } from 'stores/rematch/models/types/bookings-store';
import { IRootDispatch, IRootState } from 'stores/rematch/root-store';
import { CustomViewsModalType } from 'utilities/enum-utils';

interface AddViewButtonProps {
  openBookingViewModal: (type: CustomViewsModalType) => void;
  bookingViews: BookingView[];
  showPopover: boolean;
  onChangePopover: (visible: boolean) => void;
}

export const AddViewButton = ({
  openBookingViewModal,
  bookingViews,
  showPopover,
  onChangePopover,
}: AddViewButtonProps) => {
  const displayedBookingListingTabs = useSelector(
    (state: IRootState) => state.bookingsStore.displayedBookingListingTabs,
  );
  const dispatch = useDispatch<IRootDispatch>();
  const setDisplayedBookingListingTabs = dispatch.bookingsStore.setDisplayedBookingListingTabs;
  const setBookingListingActiveTab = dispatch.bookingsStore.setBookingListingActiveTab;

  return (
    <Popover opened={showPopover} onChange={onChangePopover}>
      <Popover.Target>
        <Button variant='default' leftSection={<Plus />} onClick={() => onChangePopover(true)}>
          Add
        </Button>
      </Popover.Target>
      <Popover.Dropdown>
        <CustomViewPopover
          pageViews={bookingViews}
          displayedPageListingTabs={displayedBookingListingTabs}
          onCreateNewView={() => openBookingViewModal(CustomViewsModalType.CREATE)}
          onDisplayTab={onChangePopover}
          setDisplayedPageListingTabs={setDisplayedBookingListingTabs}
          setPageListingActiveTab={setBookingListingActiveTab}
        />
      </Popover.Dropdown>
    </Popover>
  );
};
